import React from 'react';

import { useTheme } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { teamsList } from './teamsList';
import { Team } from './Team';

export const Teams = (): JSX.Element => {
  const theme = useTheme();
  const darkGreen = theme.palette.primary.dark;
  // @ts-ignore: Shades are currently not poperly defined in theme
  const midGreen = theme.palette.primary[600];
  const lightGreen = theme.palette.primary.main;

  const getColor = (index: number) => {
    const moduleResult = index % 3;
    if (moduleResult === 0) {
      return darkGreen;
    }

    if (moduleResult === 1) {
      return midGreen;
    }

    return lightGreen;
  };

  return (
    <>
      <Grid container spacing={2}>
        {teamsList.map((team, index) => (
          <Team
            key={team.name}
            name={team.name}
            desc={team.desc}
            descMore={team.descMore}
            color={getColor(index)}
          />
        ))}
      </Grid>
    </>
  );
};
